import React from 'react';
import PropTypes from 'prop-types';
import OfficePageCitiesLettersItem from './OfficePageCitiesLettersItem';
import Styles from './OfficePageCitiesLetters.scss';

const OfficePageCitiesLetters = ({ letters, activeLetter, setActiveLetter }) => {

  if (letters.length === 0) {
    return null;
  }

  return (
    <div className={Styles.letters}>
      {letters.map((letter) => (
        <OfficePageCitiesLettersItem
          key={letter}
          isActive={letter === activeLetter}
          setActiveItem={() => setActiveLetter(letter)}
        >
          {letter}
        </OfficePageCitiesLettersItem>
      ))}
    </div>
  );
};

OfficePageCitiesLetters.propTypes = {
  letters: PropTypes.array,
  activeLetter: PropTypes.string,
  setActiveLetter: PropTypes.func,
};

export default OfficePageCitiesLetters;
